export const ETHER_ADDRESS = '0x0000000000000000000000000000000000000000'
export const GREEN = 'success'
export const RED = 'danger'


export const DECIMALS = (10 ** 18)

export const ether = (wei) => {
    if(wei){
        return (wei / DECIMALS) //18 decimals 
    }
}

//Format balance
export const formatBalance = (balance) => {
    const precision = 100 //2 decimal places
    balance = ether(balance);
    balance = Math.round(balance * precision) / precision  //round to two decimals places
    return balance
}

//Tokens and ether have same decimals
export const tokens = ether

export const formatTimestamp = (timestamp) => {
    var a = new Date(timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;

  }

